module.exports = __webpack_public_path__ + "static/media/bronchi.6038d3f1.ogg";